import { useState } from "react";
import { shareCanvasRenderProjection, type CanvasRenderProjection } from "./render-projection.js";

/** Keep the previous projection in React-owned state, not a ref/cache mutated by
 * speculative renders. The guarded render-phase update retries this component
 * before committing children; abandoned renders cannot publish their baseline.
 * The current input remains authoritative even if React discards all sharing. */
export function useRenderProjection(nodes: CanvasRenderProjection["nodes"], edges: CanvasRenderProjection["edges"]): CanvasRenderProjection {
  const [previous, setPrevious] = useState(() => ({ nodes, edges, output: { nodes, edges } }));
  if (previous.nodes !== nodes || previous.edges !== edges) {
    const output = shareCanvasRenderProjection({ nodes, edges }, previous.output);
    setPrevious({ nodes, edges, output });
    return output;
  }
  return previous.output;
}
